/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, Input, OnInit} from '@angular/core';
import {Animal} from '../../../_models/animal';

@Component({
  selector: 'app-table-pending-animals',
  templateUrl: './table-pending-animals.component.html',
  styleUrls: ['./table-pending-animals.component.scss']
})
export class TablePendingAnimalsComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              COMPONENT I/O                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  @Input() data: Animal[];

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor() {
    // This is intentional
  }

  ngOnInit(): void {
    // This is intentional
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              VALUE GETTERS                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get showNumberCountry(): boolean {
    return this.data ? this.data.filter((it: Animal) => {
      return it._embedded && it._embedded.animalDetail && it._embedded.animalDetail.allowNumber;
    }).length > 0 : false;
  }

}
